function MessageService(_, storage, Device, $rootScope, messageProcessors) {
    var storeInfo = _.debounce(function() {

        storage.setItem('getinfo', JSON.stringify(Device.info))

    }, 2000)

    //Flag a message as being read
    function read(messageOrId) {
        var message = Device.resolveMessage(messageOrId)
        var readResult = null

        if (typeof $rootScope != "undefined" && $rootScope.$offline) {
            storage.setItem(`$_read_${message.ATTRIBUTES.id}`, message.ATTRIBUTES.id)
            message.ATTRIBUTES.status = 'read'
            storeInfo()
            readResult = Promise.resolve(false)
        } else {
            readResult = Device.read(message)
        }
        messageProcessors.update()

        return readResult
    }

    function redeemed(messageOrId) {
        var message = Device.resolveMessage(messageOrId)
        var redeemResult = null

        if (typeof $rootScope != "undefined" && $rootScope.$offline) {
            storage.setItem(`$_redeemed_${message.ATTRIBUTES.id}`, message.ATTRIBUTES.id)
            message.ATTRIBUTES.status = 'redeemed'
            storeInfo()
            redeemResult = Promise.resolve(false)
        } else {
            redeemResult = Device.redeemed(message)
        }

        messageProcessors.update()

        return redeemResult
    }

    function received(messageOrId) {
        return Device.received(messageOrId)
    }

    function getMessage(id) {
        return Device.getMessage(id)
    }

    //When coming online process the events

    if (typeof $rootScope != "undefined") {
        $rootScope.$on('online', ()=> {
            storage.keys(k=>k.startsWith('$_read_')).forEach(r=>{
                try {
                    Device.read(Device.getMessage(storage.getItem(r)))
                    storage.removeItem(r)
                } catch(e) {
                    console.error("Could not read", r)
                }
            })
            storage.keys(k=>k.startsWith('$_redeemed_')).forEach(r=>{
                try {
                    Device.redeemed(Device.getMessage(storage.getItem(r)))
                    storage.removeItem(r)
                } catch(e) {
                    console.error("Could not read", r)
                }
            })
        })
    }

    function getInfo() {
        return Device.getInfo()
    }

    return Object.defineProperties({
        read: read,
        redeemed: redeemed,
        received: received,
        getMessage: getMessage,
        getInfo: getInfo
    }, {
        current: {
            get: function() {
                return Device.info.messages
            }
        }
    })
}

MessageService._depends = {
    symbol : "3r/message-api/message-service/MessageService",
    modules : [
        "_",
        "3r/storage",
        "3r/Device"
    ]
}

MessageService.$inject = ['$rootScope', 'messageProcessors']

if (typeof exports == "object") {
    exports.MessageService = MessageService
}
